var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "160px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "应用", prop: "appid" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.formData.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "appid", $$v)
                    },
                    expression: "formData.appid"
                  }
                },
                _vm._l(_vm.appListAllData, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "支付类型", prop: "payment_type_id" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.formData.payment_type_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "payment_type_id", $$v)
                    },
                    expression: "formData.payment_type_id"
                  }
                },
                _vm._l(_vm.appPaymentTypeAllData, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.type_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "研发商品", prop: "product" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入研发商品" },
                model: {
                  value: _vm.formData.product,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "product", $$v)
                  },
                  expression: "formData.product"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "支付渠道配置商品", prop: "third_part_product" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.formData.third_part_product,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "third_part_product", $$v)
                  },
                  expression: "formData.third_part_product"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "研发价格", prop: "price" }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  clearable: "",
                  placeholder: "请输入价格"
                },
                model: {
                  value: _vm.formData.price,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "price", $$v)
                  },
                  expression: "formData.price"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "支付渠道商品价格", prop: "third_part_price" }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  clearable: "",
                  placeholder: "请输入支付渠道配置价格"
                },
                model: {
                  value: _vm.formData.third_part_price,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "third_part_price", $$v)
                  },
                  expression: "formData.third_part_price"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "折扣", prop: "discount" }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  maxlength: "6",
                  clearable: "",
                  placeholder: "请输入折扣"
                },
                model: {
                  value: _vm.formData.discount,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "discount", $$v)
                  },
                  expression: "formData.discount"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "货币代码", prop: "currency" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入货币代码" },
                model: {
                  value: _vm.formData.currency,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "currency", $$v)
                  },
                  expression: "formData.currency"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "商品名称", prop: "product_name" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入商品名称" },
                model: {
                  value: _vm.formData.product_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "product_name", $$v)
                  },
                  expression: "formData.product_name"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.clearData(false)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }